import { FeedQueryResult, LightboxRootObject } from './softbox-types.ts';
import { resolvedLanguage } from '@/i18n.ts';
import { IInterestResponse } from '@/pages/Root/services/api/interest/interest-model-definitions.ts';
import { ScheduleType } from '../types/story-types.ts';
import { API_URL, DEFAULT_ASPECT, DEFAULT_CKEY, getInitializedMomentFetcher, } from '@moment/net/fetch-contstants.ts';

export const generateFetchFeedQuery = (schedule: string) => {return (options?: { lang?: string; logger?: any; trending?: boolean }) => {
  return async (): Promise<FeedQueryResult> => {
    const momentFetcher = await getInitializedMomentFetcher();
    const logger = options ? options.logger : undefined;
    logger?.log(`generateFetchFeedQuery, schedule = ${schedule}`);
    const lang = options ? options.lang : undefined;
    const language = lang || resolvedLanguage('en');
    const url = `${API_URL}/wp/v1/daily${options?.trending ? `/trend/${schedule}` : ''}?ckey=${DEFAULT_CKEY}&mp_lang=${language}&sched=${schedule}&previewAspect=${DEFAULT_ASPECT}`;
    const res = await momentFetcher.fetch(url, options);
    logger?.log(`generateFetchFeedQuery - hit\n${url}\nstatus=${res.status}`);
    const data: LightboxRootObject = await res.json();

    const resInterests = await momentFetcher.fetch(
      `${API_URL}/wp/v1/interests?ckey=${DEFAULT_CKEY}&previewAspect=${DEFAULT_ASPECT}`,
      options
    );
    logger?.log(
      `generateFetchFeedQuery - hit\n${API_URL}/wp/v1/interests?ckey=${DEFAULT_CKEY}&previewAspect=${DEFAULT_ASPECT}\nstatus=${resInterests.status}`
    );
    const interests = await resInterests.json();
    const output = {
      news: data,
      interests,
    } satisfies FeedQueryResult;

    return output;
  };
}};

type paginatedFeedQueryReturnType = {
  data: LightboxRootObject;
  currentPage: number;
  nextPage: number | null;
};

export const fetchPaginatedFeedQuery = async ({
  interests,
  schedule,
  pageParam,
}: {
  interests: IInterestResponse;
  schedule: string;
  pageParam: number;
}) => {
  const momentFetcher = await getInitializedMomentFetcher();
  const language = resolvedLanguage('en');

  /*
    ** commenting out for future implementations, after personalization is updated **

    const interest = interests.interests[Math.floor(Math.random() * interests.interests.length)]
    const res = await fetch(
     `${API_URL}/wp/v1/personalization?ckey=${DEFAULT_CKEY}&mp_lang=${lang}&previewAspect=${DEFAULT_ASPECT}&interests=${interest.uid}&param=${pageParam}`
    );
    */
  let scheduleParam: string;

  switch (schedule) {
    case 'html5games':
      scheduleParam = ScheduleType.HTML5GAMES;
      break;
    case 'moment-galleries':
      scheduleParam = ScheduleType.MOMENT_GALLERIES;
      break;
    default:
      scheduleParam = ScheduleType.STANDARD_READ;
      break;
  }

  const url = `${API_URL}/wp/v1/daily?ckey=${DEFAULT_CKEY}&mp_lang=${language}&previewAspect=${DEFAULT_ASPECT}&sched=${scheduleParam}&param=${pageParam}`;
  const res = await momentFetcher.fetch(url);
  const data: LightboxRootObject = await res.json();

  const output = {
    data: data,
    currentPage: pageParam,
    nextPage: pageParam + 1,
  } satisfies paginatedFeedQueryReturnType;

  return output;
};
